module.exports = require("webpack-node-externals");